<bento-tile-ribbon [items]="tileItems"
[showCollapseToggle]="false" (onLinkClick) = "onTileLinkClick($event)"
>
</bento-tile-ribbon>
